import { WorkOSUser } from '@/components/UserProfileSettingDetail'
import showToastNotification from '@/hooks/useShowToast'
import { trpc } from '@/utils/trpc'
import { useLocalStorage } from 'usehooks-ts'

export const useSwitchAccount = () => {
  const [user, set_user] = useLocalStorage<WorkOSUser | undefined>('_wos_user', undefined)
  const { mutate: switchAccount, isPending: isSwitchingAccount } = trpc.switchAccount.useMutation({
    onSuccess: async (result) => {
      if (user) {
        set_user({
          ...user,
          mode: result.mode!,
          teamId: result.teamId ?? null,
        })
      }
      showToastNotification('success', {
        message: `Success`,
        description: `Switched account successfully.`,
      })
      setTimeout(() => window.location.reload(), 1000)
    },
    onError: (error) => {
      showToastNotification('error', {
        message: `Error switching account.`,
        description: `${error.message}`,
      })
    },
  })

  return { switchAccount, isSwitchingAccount }
}
